import FixingRobotSrc from 'shared/images/girl_fixing_robot.png'
import { DialogSettings } from 'shared/types'

export const SERVER_ERROR_DIALOG_PAYLOAD: DialogSettings = {
  title: 'errorDialog.title',
  image: FixingRobotSrc,
  text: 'errorDialog.description',
  type: 'error',
}
